import React, { useMemo } from "react";
import countryList from "react-select-country-list";
import styled from "styled-components";
import Text from "./Text";
import { PortalSelect, portalColors } from "./BusinessPortalComponents";

const InputSelector = styled(PortalSelect)`
    width: ${p => p.width || "100%"};
    min-width: 0;
    border-color: ${p => p.$isHighlighted ? portalColors.danger : portalColors.borderStrong};
    color: ${p => p.$isEmpty ? portalColors.textSoft : portalColors.text};
    margin: ${p => p.margin || "0"};
    font-weight: 600;
`;
    
const ErrorText = styled(Text)`
        color: red;
        text-align: left;
        font-size: 12px;
        margin: ${p => p.margin || "0 20px 5px"};
        white-space: pre-wrap;
    `;

function CountrySelector(props) {
    const { value, placeholder, errors, onChange, onFocus, showErrors, ...styleProps } = props;
    const options = useMemo(() => countryList().getData(), []);
    const errorsArray = errors ? errors : [];
        
    return (
        
        <div>
            <InputSelector
                $isEmpty={value === null || value === ""}
                onChange={onChange}
                value={value}
                $isHighlighted={errorsArray.length > 0}
                onFocus={onFocus}
                {...styleProps}
            >
                <option value="">{placeholder ? placeholder : "Select a country"}</option>
                {options.map((option) => (
                    <option key={option.value} value={option.value} >
                        {option.label}
                    </option>
                ))}
            </InputSelector>
            { showErrors && <ErrorText>{errorsArray}</ErrorText> }
        </div>
    );
}

export default CountrySelector;
